export enum AppRoute {
  HOME = '/',
  NOMINATE = 'nominate',
  VALIDATE_ID = ':id',
  NOT_FOUND = '*',
}
